import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { adminHttp } from "~/Admin/services/http";
import { connect } from "react-redux";
import { loadDietaries } from '../../redux/actions/general';
import SpecialRequirements from '../../../Pages/RsvpRegistration/SpecialRequirements/SpecialRequirements';
import { guestSpecialRequirements } from '../../../services/adapters/guest';
import { toast } from 'react-toastify';

const AdminEditSpecialRequirements = ({ guest, event, dietaries, onChange, dispatch, ...rest }) => {

    const [show, setShow] = useState(false);
    const [error, setError] = useState(null);

    const currentFormData = guestSpecialRequirements(guest);

    const [form, setForm] = useState({
        dietary: [],
        other_dietary: '',
        medical_needs: false,
        medical_comments: '',
        wheelchair: false,
        mobility_comments: '',
    });

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleSubmit = () => {
        toast.promise(
            adminHttp.put(`/guests/${guest.id}/requirements`, form),
            {
                pending: 'Saving Special requirements...',
                success: {
                    render() {
                        setError(null);
                        setShow(false);
                        onChange();
                        return 'Special requirements saved'
                    }
                },
                error: {
                    render() {
                        setError(error.data?.response?.data);
                        return 'Something went wrong!'
                    }
                }
            }
        )
    };

    useEffect(() => {
        dispatch(loadDietaries());
        setForm({ ...form, ...currentFormData });
    }, [])

    return (
        <>
            <button {...rest} onClick={handleShow}>Edit Special Requirements</button>

            <Modal className="guestpreview-modal" show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Special Requirements</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <SpecialRequirements
                        guest={guest}
                        formData={form}
                        dietaries={dietaries}
                        isAdmin={true}
                        onChange={setForm}
                        errors={error}
                    />
                </Modal.Body>

                <Modal.Footer>
                    <button className="btn btn-secondary btn-xs" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-primary btn-xs" onClick={handleSubmit}>
                        Save
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
    dietaries: state.general?.dietaries,
});

export default connect(mapStateToProps)(AdminEditSpecialRequirements);
